import React from 'react'
import DepartmentCardLink from './DepartmentCardLink'
import { formatDepartmentMeta, getDepartmentsTotals } from './departmentListUtils'

function DepartmentSection({
  title,
  departments,
  group,
  canReorder,
  onDragStart,
  onDragOver,
  onDrop,
}) {
  if (!departments?.length) return null

  return (
    <section className="department-section">
      <div className="department-section-head">
        <h2 className="department-section-title">{title}</h2>
        <div className="department-section-meta">{formatDepartmentMeta(getDepartmentsTotals(departments))}</div>
      </div>
      <div className="dept-cards">
        {departments.map((department) => (
          <DepartmentCardLink
            key={department.id}
            department={department}
            group={group}
            canReorder={canReorder}
            onDragStart={onDragStart}
            onDragOver={onDragOver}
            onDrop={onDrop}
          />
        ))}
      </div>
    </section>
  )
}

export default DepartmentSection
